// src/components/HeroCarousel.tsx
import React from "react";
import { Box, Button } from "@mui/material";
import Slider from "react-slick";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

// Replace these imports with your actual local image paths or network URLs
import HeroImg1 from "../img/hero-banner1.webp"; 
import HeroImg2 from "../img/hero-banner2.webp";
import HeroImg3 from "../img/hero-banner3.webp";

interface HeroCarouselProps {
  onScrollClick: () => void;
}

// 2. Pass the interface into React.FC like this: React.FC<HeroCarouselProps>
const HeroCarousel: React.FC<HeroCarouselProps> = ({ onScrollClick }) => {
  const bannerImages = [HeroImg1, HeroImg2, HeroImg3];

  // Carousel Configuration
  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: false,
    arrows: false, // Clean, minimalist look without bulky side arrows
    appendDots: (dots: any) => (
      <Box 
        sx={{ 
          position: "absolute", 
          bottom: "20px",
          // Hides the dot container completely on small screens, displays it on tablet/desktop
          display: { xs: "none", sm: "block" } 
        }}
      >
        {dots}
      </Box>
    ),
    customPaging: () => (
      <Box
        sx={{
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          backgroundColor: "rgba(255, 255, 255, 0.5)",
          display: "inline-block",
          mx: 0.5,
          transition: "all 0.3s ease",
          "&.slick-active": {
            backgroundColor: "#fff",
            transform: "scale(1.2)"
          },
          ".slick-active &": {
            backgroundColor: "#fff"
          }
        }}
      />
    )
  };

 return (
    <Box 
      sx={{ 
        width: "100%",
        aspectRatio: "1920 / 700", 
        maxHeight: "700px", 
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#f5f5f5",
        mb: 4,
        mt: 0, // 1. Guarantees no top spacing pushing it down
        /* Core structural slick containers stay stretched to fill the aspect-ratio shell */
        "& .slick-slider": { height: "100%", position: "relative" },
        "& .slick-list": { height: "100%" },
        "& .slick-track": { height: "100%", display: "flex" },
        "& .slick-slide > div": { height: "100%" } 
      }}
    >
      <Slider {...carouselSettings}>
        {bannerImages.map((src, index) => (
          <Box 
            key={index} 
            sx={{ 
              width: "100%", 
              height: "100%", 
              position: "relative",
              outline: "none"
            }}
          >
            <Box
              component="img"
              src={src}
              alt={`Cozy Bud Banner ${index + 1}`}
              sx={{
                width: "100%",
                height: "100%",
                // 2. Switched to 'contain' or 'fill' so the image strictly respects container bounds
                objectFit: "contain", 
                objectPosition: "center",
                display: "block"
              }}
            />
          </Box>
        ))}
      </Slider>

      {/* // Floating Shop Now Call-to-Action Button
      <Button
        variant="contained"
        onClick={onScrollClick}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{
          position: "absolute",
          // 3. Adjusted to use percentage so it stays perfectly positioned as the banner shrinks on smaller displays
          bottom: "8%", 
          left: "50%",
          transform: "translateX(-50%)",
          backgroundColor: "rgba(255, 255, 255, 0.85)",
          color: "#555",
          fontWeight: "500",
          fontSize: { xs: "10px", sm: "14px" }, // Slightly smaller font on mobile layout
          px: { xs: 2.5, sm: 4 },
          py: { xs: 0.8, sm: 1.5 },
          borderRadius: "30px",
          textTransform: "none",
          boxShadow: "0px 4px 15px rgba(0,0,0,0.15)",
          backdropFilter: "blur(4px)",
          transition: "all 0.3s ease-in-out",
          zIndex: 2,
          "&:hover": {
            backgroundColor: "#cdc3f8",
            color: "#fff",
            boxShadow: "0px 6px 20px rgba(127, 190, 235, 0.4)",
            transform: "translateX(-50%) translateY(-2px)",
          }
        }}
      >
        Explore Collections
      </Button> */}
    </Box>
  );
};

export default HeroCarousel;